import { inCommands } from '../../../concepts/commands/CommandRegistry';
import { Package, PackageHost } from '../../Container';
import { ExportAdapterLibrary } from './ExportAdapter';
import { exportData, exportPdf, exportTrello } from './ExportCommands';
import { ExportService } from './ExportService';
import { ExportSourceLibrary, inExportSourceProvider } from './ExportSource';
import { StandardExportSourceProvider } from './sources/StandardExportSourceProvider';

export class ExportPackage implements Package {

    public install = (host: PackageHost) => host
        .register(ExportAdapterLibrary, 'singleton')
        .register(ExportSourceLibrary, 'singleton')
        .register(ExportService, 'transient')
        .plug(inExportSourceProvider(StandardExportSourceProvider))
        // .plug(inExportAdapter(
        //     AxisPositionExportAdapter,
        // ))
        .plug(inCommands(exportData, exportPdf, exportTrello))
        ;
}
